import { makeStyles } from '@material-ui/core';
import { calculateWidth, vh } from 'src/common/helpers/dimension-helper';

interface CheckoutButtonStyleProps {
  tendering?: boolean;
}

// Until the theme gets typed...
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const styles = makeStyles((theme: any) => ({
  checkoutButtonLabelContainer: {
    height: '6.29vh',
    alignContent: 'center',
    whiteSpace: 'nowrap',
  },
  checkoutButtonLabelCustomerContainer: {
    paddingLeft: 'calc(0.732vw + 16px)',
    paddingRight: '1vw',
  },
  checkoutButtonText: {
    color: 'inherit',
    textAlign: 'left',
    '@media (aspect-ratio: 4/3)': {
      fontSize: vh(1.95),
    },
    fontSize: vh(2.594),
  },
  drawerLimitIcon: {
    paddingRight: '5%',
    fontSize: vh(3.125),
    '@media(aspect-ratio: 4/3)': {
      fontSize: vh(2.78),
    },
  },

  checkoutButton: ({ tendering }: CheckoutButtonStyleProps) => {
    const baseColors = {
      background: theme?.configColors?.secondaryColor || theme.secondaryContrast,
      color: theme?.configColors?.secondaryText || theme.defaultTextColor,
    };
    const tenderColors = {
      background: theme.watermark,
      color: theme.defaultTextColor,
    };
    const colors = tendering ? tenderColors : baseColors;
    return {
      boxShadow: 'none !important',
      width: '100%',
      fontSize: vh(2.594),
      backgroundColor: colors.background,
      color: colors.color,
      '&:hover': {
        backgroundColor: colors.background,
        color: colors.color,
      },
      '&.Mui-disabled': {
        backgroundColor: colors.background,
        color: colors.color,
        opacity: 0.4,
      },
    };
  },

  checkoutButtonSmallForm: ({ tendering }: CheckoutButtonStyleProps) => {
    const baseColors = {
      background: theme?.configColors?.secondaryColor || theme.secondaryContrast,
      color: theme?.configColors?.secondaryText || theme.defaultTextColor,
    };
    const tenderColors = {
      background: theme.watermark,
      color: theme.defaultTextColor,
    };
    const colors = tendering ? tenderColors : baseColors;
    return {
      boxShadow: 'none !important',
      width: calculateWidth(304, 1024).stringValue,
      fontSize: vh(2.594),
      backgroundColor: colors.background,
      color: colors.color,
      '&:hover': {
        backgroundColor: colors.background,
        color: colors.color,
      },
      '&.Mui-disabled': {
        backgroundColor: colors.background,
        color: colors.color,
        opacity: 0.4,
      },
    };
  },

  checkoutButtonCustomerDisplay: ({ tendering }: CheckoutButtonStyleProps) => {
    const baseColors = {
      background: theme?.configColors?.secondaryColor || theme.secondaryContrast,
      color: theme?.configColors?.secondaryText || theme.defaultTextColor,
    };
    const tenderColors = {
      background: theme.watermark,
      color: theme.defaultTextColor,
    };
    const colors = tendering ? tenderColors : baseColors;
    return {
      boxShadow: 'none !important',
      width: '100%',
      fontSize: vh(2.594),
      backgroundColor: colors.background,
      color: colors.color,
      '&:hover': {
        backgroundColor: colors.background,
        color: colors.color,
      },
      '&.Mui-disabled': {
        backgroundColor: colors.background,
        color: colors.color,
        opacity: 0.4,
      },
    };
  },
}));
